module.exports = __webpack_public_path__ + "static/media/hot_gsyx.8afd9f95.png";